export default __webpack_public_path__ + "static/media/List-documentation.37d222b6.md";